import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { useAuth } from '@context/shared/AuthContext';
import { usePageTracking } from '@hooks/client/use-page-tracking';
import { getDefaultLandingPath } from '@config/shared/roles';

// Route modules
import { getAuthRoutes } from './modules/auth.routes';
import { getClientRoutes } from './modules/client.routes';
import { useAdminRoutes } from './modules/admin.routes';
import { LoadingFallback } from './modules/shared';

const AppRoutes = () => {
  const { features, isAuthenticated, loading, user } = useAuth();
  usePageTracking();

  // Get admin routes with features
  const adminRoutes = useAdminRoutes(features);

  // Show loading screen while auth and features are being initialized
  if (loading) {
    return <LoadingFallback />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Root redirect */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to={getDefaultLandingPath(user?.roleId)} replace />
            ) : (
              <Navigate to="/auth/login" replace />
            )
          }
        />

        {/* Auth routes */}
        {getAuthRoutes()}

        {/* Admin routes - prefixed with /admin */}
        {adminRoutes}

        {/* Client routes - at root level (no /client prefix). Also holds the
            403/404 pages and the catch-all for unknown URLs, inside the client
            layout; signed out, its guard sends them to login. */}
        {getClientRoutes()}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
